const PrivacyPolicy = () => {
  return (
    <div className="overflow-hidden">
      <section className="relative py-24 hero-gradient mesh-gradient">
        <div className="absolute top-20 right-10 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold font-['Outfit'] tracking-tighter mb-6">
              Privacy Policy
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              How Jnan Innovative IT Solutions collects, uses, protects, and deletes personal and business information.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            <p><strong>Effective Date:</strong> 4/19/2026</p>
            <p><strong>Last Updated:</strong> 6/28/2026</p>

            <h2>1. Introduction</h2>
            <p>
              Jnan Innovative IT Solutions ("Jnanit", "we", "our", or "us") is committed to protecting customer, business, and integration data. This Privacy Policy explains how we handle information collected through our website, services, software integrations, and Amazon Selling Partner API (SP-API) solutions.
            </p>
            <br />

            <h2>2. Information We Collect</h2>
            <ul>
              <li><strong>Contact information:</strong> name, email address, phone number, company name, and inquiry details.</li>
              <li><strong>Technical information:</strong> IP address, browser type, device information, cookies, usage logs, and security events.</li>
              <li><strong>Business and integration data:</strong> order, inventory, catalog, shipment, fulfillment, tax, and API data required to provide integration services.</li>
              <li><strong>Amazon SP-API data:</strong> Amazon seller account data and, only where approved and required, Amazon customer personally identifiable information (PII) for merchant-fulfilled shipping, tax invoicing, tax remittance, or legal/regulatory obligations.</li>
            </ul>
            <br />

            <h2>3. Amazon Customer PII</h2>
            <p>
              Amazon customer PII may include names, addresses, phone numbers, email addresses, order details, shipment information, gift-message content, IP addresses, device identifiers, or other information that can identify an individual. We classify Amazon customer PII as Restricted/PII and apply the highest level of protection.
            </p>
            <p>
              We request and process Amazon customer PII only when it is necessary for an approved purpose, such as merchant-fulfilled shipping, carrier label generation, delivery coordination, tax invoicing, tax remittance, or compliance with applicable law. We do not use Amazon customer PII for marketing, retargeting, customer profiling, resale, review manipulation, unrelated analytics, or cross-seller aggregation.
            </p>
            <br />

            <h2>4. How We Use Information</h2>
            <ul>
              <li>Provide, operate, support, and improve our services.</li>
              <li>Respond to inquiries, quotations, demos, and support requests.</li>
              <li>Build, maintain, and troubleshoot integrations with Amazon SP-API and other platforms.</li>
              <li>Synchronize orders, inventory, fulfillment, pricing, reporting, or tax-related workflows as authorized by the customer.</li>
              <li>Protect systems, detect security incidents, prevent fraud, and comply with legal obligations.</li>
            </ul>
            <br />

            <h2>5. Data Governance and Processing Records</h2>
            <p>
              We maintain documented data handling, data classification, privacy, retention/deletion, and data subject request policies. For Amazon SP-API data, we maintain processing records that identify the data fields processed, source API or report, business purpose, storage location, access roles, retention period, sharing/subprocessor involvement, and secure deletion method.
            </p>
            <br />

            <h2>6. Data Sharing</h2>
            <p>
              We do not sell personal data or Amazon customer PII. We share information only with authorized service providers, subprocessors, platforms requested by the customer, or legal authorities when required. Any service provider that processes protected data must be bound by confidentiality and data protection obligations.
            </p>
            <br />

            <h2>7. Security Controls</h2>
            <p>
              We use administrative, technical, and physical safeguards including role-based access control, least-privilege permissions, secure authentication, HTTPS/TLS in transit, encryption at rest for PII, credential protection, audit logging, vulnerability management, and incident response procedures.
            </p>
            <br />

            <h2>8. Retention and Deletion</h2>
            <p>
              We retain information only as long as necessary to provide services, meet contractual obligations, or comply with law. Amazon customer PII is retained only for the approved purpose and is deleted no later than 30 days after order delivery unless a longer retention period is legally required.
            </p>
            <br />

            <h2>9. Your Rights</h2>
            <p>
              You may request access, correction, deletion, or restriction of your personal information by contacting us at <strong>info@jnanit.com</strong>. We will respond according to applicable law and contractual obligations.
            </p>
            <br />

            <h2>10. Cookies</h2>
            <p>
              We may use cookies and similar technologies to improve website functionality, analyze traffic, and support security. You can manage cookies through your browser settings.
            </p>
            <br />

            <h2>11. Third-Party Links and Platforms</h2>
            <p>
              Our website and services may link to or integrate with third-party platforms, including Amazon. Their privacy practices are governed by their own policies.
            </p>
            <br />

            <h2>12. Updates</h2>
            <p>
              We may update this Privacy Policy periodically. Updates will be posted on this page with a revised last-updated date.
            </p>
            <br />

            <h2>13. Contact</h2>
            <p>
              Jnan Innovative IT Solutions<br />
              Email: info@jnanit.com<br />
              Website: https://jnanit.com
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
